import { Button } from './Button';

interface EmptyStateCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

export const EmptyStateCard = ({ 
  icon, 
  title, 
  description, 
  buttonText, 
  onButtonClick 
}: EmptyStateCardProps) => {
  return (
    <div className="flex items-center justify-center min-h-[300px] p-4">
      <div className="max-w-md w-full bg-white rounded-[16px] border border-[#E5E7EB] shadow-sm p-8 text-center">
        {/* Icon */}
        <div className="w-16 h-16 bg-[#F7F8FA] rounded-full flex items-center justify-center mx-auto mb-4">
          {icon}
        </div>

        {/* Content */}
        <h2 className="text-xl font-bold text-[#111827] mb-2">
          {title}
        </h2>
        <p className="text-[#6B7280] mb-6">
          {description}
        </p>

        {/* CTA */}
        {buttonText && onButtonClick && (
          <Button
            onClick={onButtonClick}
            variant="primary"
            className="w-full"
          >
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};
